import React from 'react'

const Input = ({value,defaultValue, className, containerClassName, labelClassName, type, placeholder, textLabel, onChange, name,onFocus, onBlur, maxLength, required=false }) => {

  return (
    <div className={`inputComponent ${containerClassName}`}>
      <label className={labelClassName} >{textLabel} {required && "*"}</label>
      <input maxLength={maxLength} onFocus={onFocus} onBlur={onBlur} defaultValue={defaultValue} value={value} className={className} type={type} placeholder={placeholder}  onChange={e => { 
        if (maxLength && e.target.value.length < maxLength + 1) {
          onChange(e)
        } else if (!maxLength) {
          onChange(e)
        }
      }} name={name} />
    </div>
  )
}

export default Input